import { SocketClient } from './socket.client';
import { Actuator } from './actuator';
import { EventTranxceiver } from './tranxceiver';
import { UserOperationSyncInterceptor } from './user.action.interceptor';
import { Car3DActionSync } from '../actionSync/car3d.action.sync';
import * as EventType from '../eventBusType';
import util from '../../utils/util';
import socketApi from '../../apis/ws.api';
import tokenPackager from './token.package.config';

class TokenParameterPackager {
  encodeMessage(userId) {
    const sessionidStr = util.getCookie('sessionid') || '';
    let seeeionId = '';
    if (sessionidStr) {
      seeeionId = sessionidStr.split('||')[0] || '';
    }
    const deviceId = util.getCookie('app_deviceid');
    const TokenRquestBody = tokenPackager.apipackage.TokenRquestBody;
    const message = TokenRquestBody.create({
      appId: 'dealer.vr',
      timestamp: new Date().getTime().toString(),
      nonceStr: util.getRandomStr(),
      userId: userId || deviceId || seeeionId || util.getRandomStr(4),
    });
    return TokenRquestBody.encode(message).finish();
  }
}
/**
 * socketClient 创建工厂
 */
const socketFactory = {
  createSocketClient(opts = {}) {
    const requestData = new TokenParameterPackager().encodeMessage(opts.userId);
    return socketApi.getToken(Array.from(requestData)).then((data) => {
      if (data.returncode === 0) {
        const token = data.result;
        opts.token = token;
        const socket = new SocketClient(opts);
        socket.on('connect', function () {
          /**
           * 事件收发器
           */
          const actuator = new Actuator();
          const tranxceiver = new EventTranxceiver(socket, {
            isReceive: opts.isReceive || true,
            isSend: opts.isSend || true,
          });
          tranxceiver.on(EventType.RECEIVED_MESSAGE, (msg) => {
            actuator.execute(msg.id, msg.methodName, msg.args);
          });
          const car3DActionSync = new Car3DActionSync(tranxceiver);
          car3DActionSync.listen();
          const userOperationSyncInterceptor = new UserOperationSyncInterceptor(tranxceiver);
          socket.on('disconnect', function () {
            tranxceiver.dispose();
            userOperationSyncInterceptor.dispose();
            car3DActionSync.dispose();
          });
        });
        return socket;
      }
    });
  },
};
export { socketFactory };
